export default function mobileNav() {
    return {
        get isOpen() {
            return this.$store.nav.mobileOpen;
        },

        get isClosed() {
            return !this.$store.nav.mobileOpen;
        },

        get expandedAttr() {
            return String(this.$store.nav.mobileOpen);
        },

        open() {
            this.$store.nav.mobileOpen = true;
        },

        close() {
            this.$store.nav.mobileOpen = false;
        },

        toggle() {
            this.$store.nav.mobileOpen = !this.$store.nav.mobileOpen;
        },

        init() {},
        destroy() {},
    };
}
